import { BadgeProps } from 'lib/components/Badge';
import { OrderStatus } from 'lib/types/order';
import { NewspaperOrderStatus } from 'lib/types/newspaperOrder';
import { logAndCaptureMessage } from 'utils';
import { SyncAttemptStatus } from 'lib/types/syncAttempt';

export const getBadgeStatusForNewspaperOrderStatus = (
  newspaperOrderStatus: NewspaperOrderStatus
): BadgeProps['status'] => {
  switch (newspaperOrderStatus) {
    case NewspaperOrderStatus.IN_REVIEW:
      return 'warning';
    case NewspaperOrderStatus.COMPLETE:
    case NewspaperOrderStatus.CONFIRMED:
      return 'success';
    case NewspaperOrderStatus.AWAITING_REVIEW:
      return 'critical';
    case NewspaperOrderStatus.CANCELLED:
    case NewspaperOrderStatus.ARCHIVED:
    case NewspaperOrderStatus.DELETED:
    case NewspaperOrderStatus.DRAFT:
      return undefined;
    default:
      logAndCaptureMessage('Unexpected newspaper order status', {
        newspaperOrderStatus
      });
      return undefined;
  }
};

export const getBadgeStatusForOrderStatus = (
  orderStatus: OrderStatus
): BadgeProps['status'] => {
  switch (orderStatus) {
    case OrderStatus.DRAFT:
      return undefined;
    case OrderStatus.PENDING:
      return 'warning';
    case OrderStatus.CANCELLED:
      return 'critical';
    case OrderStatus.COMPLETE:
      return 'success';
    default:
      logAndCaptureMessage('Unexpected order status', {
        orderStatus
      });
  }
};

export const getBadgeAndTooltipPropsForSyncAttemptInfo = (
  syncAttemptStatus?: SyncAttemptStatus
): {
  badgeStatus: BadgeProps['status'];
  badgeLabel: string;
} => {
  switch (syncAttemptStatus) {
    case SyncAttemptStatus.SUCCESS:
      return {
        badgeStatus: 'success',
        badgeLabel: 'Success'
      };
    case SyncAttemptStatus.SKIPPED:
    case SyncAttemptStatus.BAD_REQUEST:
      return {
        badgeStatus: 'warning',
        badgeLabel: 'Blocked'
      };
    case SyncAttemptStatus.INTERNAL_ERROR:
    case SyncAttemptStatus.EXTERNAL_ERROR:
      return {
        badgeStatus: 'critical',
        badgeLabel: 'Error'
      };
    case SyncAttemptStatus.IN_PROGRESS:
      return {
        badgeStatus: 'info',
        badgeLabel: 'In Progress'
      };
    default:
      return {
        badgeStatus: 'info',
        badgeLabel: 'Pending'
      };
  }
};

export const getStatusBadgeText = (orderStatus: OrderStatus): string => {
  switch (orderStatus) {
    case OrderStatus.PENDING:
      return 'In Progress';
    default:
      return orderStatus;
  }
};
